module.exports = __webpack_public_path__ + "static/media/2.a7eecf9d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/brest/2.JPG
// module id = 216
// module chunks = 0